import React from "react";
import { Dropdown } from "aible";
import styles from "./style.module.css";

// import Waterfall from "components/Waterfall/Waterfall";
import Waterfall from "components/MonitoringMobile/WaterfallMobile";
import AlertCardGroup from "components/MonitoringMobile/AlertCardGroup";
import HorizontalList from "components/MonitoringMobile/HorizontalList";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

const demoBars = {
  weekly: [
    {
      label: "Marketing",
      value: 40
    },
    {
      label: "Sales",
      value: 115
    },
    {
      label: "Services",
      value: 10
    },
    {
      label: "Other",
      value: 20
    }
  ],
  monthly: [
    {
      label: "Marketing",
      value: 70
    },
    {
      label: "Sales",
      value: 45
    },
    {
      label: "Services",
      value: 35
    },
    {
      label: "Other",
      value: 35
    }
  ],
  quarterly: [
    {
      label: "Marketing",
      value: 90
    },
    {
      label: "Sales",
      value: 25
    },
    {
      label: "Services",
      value: 25
    },
    {
      label: "Other",
      value: 15
    }
  ],
  yearly: [
    {
      label: "Marketing",
      value: 70
    },
    {
      label: "Sales",
      value: 35
    },
    {
      label: "Services",
      value: 65
    },
    {
      label: "Other",
      value: 25
    }
  ]
};

export default class MonitoringMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMode: "Overall"
    };

    this.setSelectedMode = this.setSelectedMode.bind(this);
  }

  setSelectedMode(key) {
    this.setState({ selectedMode: key });
  }

  prepBars() {
    const { profits, projectData } = this.props;

    let retBars = [];
    for (let idx in profits) {
      if (profits[idx]) {
        retBars.push({
          label: projectData[idx].name,
          id: projectData[idx].id,
          value: profits[idx]
        });
      } else {
        retBars.push(undefined);
      }
    }

    return retBars;
  }

  render() {
    const { displayType, updateDisplayType, projectData, loadStatus, projectIDs, warningsGroup, getMontiors } =
      this.props;

    const { selectedMode, barData } = this.state;
    const fullAssetHeight = window.innerHeight - 60 + "px";

    const dataBars = this.prepBars();

    const monitor = getMontiors(projectIDs, warningsGroup);

    return (
      <div className={styles.fullAsset} style={{ height: fullAssetHeight }}>
        {loadStatus != "loaded" ? (
          <LoadingIndicator />
        ) : monitor.length == 0 ? (
          <div>No monitoring data exists in this workspace</div>
        ) : (
          <div>
            {/* <Dropdown
                                className={styles.dropdown}
                                selected={displayType}
                                isDark={true}
                                options={[
                                {
                                    label: 'Weekly',
                                    value: 'weekly',
                                    className: styles.smallBtn
                                },
                                {
                                    label: "Monthly",
                                    value: 'monthly',
                                    className: styles.smallBtn
                                },
                                {
                                    label: "Quarterly",
                                    value: 'quarterly',
                                    className: styles.smallBtn
                                },
                                {
                                    label: "Yearly",
                                    value: 'yearly',
                                    className: styles.smallBtn
                                }
                                ]}
                                onChange={options => updateDisplayType(options.value)}
                            /> */}
            {/* Revive Dropdown when timing mechanism is developed */}
            <div className={styles.overview}>{"Project Overview"}</div>
            <Waterfall
              {...this.props}
              projectData={projectData}
              selectedMode={selectedMode}
              className={styles.waterfall}
              bars={dataBars}
              isStacked
            />
            <AlertCardGroup {...this.props} monitor={monitor} />
            <HorizontalList names={dataBars} selectedMode={selectedMode} setSelectedMode={this.setSelectedMode} />
          </div>
        )}
      </div>
    );
  }
}
